var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.6515,
    stroke: "#0080B1",
    strokeWidth: 0.69697
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8541 18.7056L21.7355 20.6501C21.4846 21.0787 21.6937 21.4342 22.185 21.4342H23.5127C24.0146 21.4342 24.2132 21.7897 23.9623 22.2183L22.8541 24.1628",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9859 29.3178V28.1051C16.5814 26.6519 14.6055 23.8187 14.6055 20.8078C14.6055 15.6328 19.3623 11.5764 24.7359 12.7473C27.0987 13.2701 29.1686 14.8382 30.2455 17.0023C32.4305 21.3932 30.1305 26.056 26.7536 28.0946V29.3073C26.7536 29.6105 26.8686 30.311 25.75 30.311H19.9896C18.8396 30.3214 18.9859 29.8719 18.9859 29.3178Z",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1953 33.4596C21.5894 32.7801 24.1194 32.7801 26.5135 33.4596",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleEnergy);
export default __webpack_public_path__ + "static/media/icon-circle-energy.f21fa84232521374b106ec44baee2c47.svg";
export { ForwardRef as ReactComponent };